import "./AppStyle.ts";
import Home from "./pages/home/home";

const App = () => {
  return <Home />;
};

export default App;
